import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
}

/**
 * Generic page header component for displaying the page title and description.
 * @param param0 - Props for the PageHeader component.
 * @returns The rendered PageHeader component.
 */
export const PageHeader = ({ title, description }: PageHeaderProps) => {
  return (
    <div className='w-full py-4 sm:py-6 md:py-8 px-4 sm:px-8 md:px-14 bg-white border-b border-gray-700 flex flex-col sm:flex-row gap-4 sm:gap-0 sm:justify-between sm:items-center'>
      <div className='flex flex-col gap-1'>
        <h2 className='font-medium text-cxportal-blue'>{title}</h2>
        {description && (
          <p className='text-sm font-semibold text-l flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-0'>
            <span className='font-semibold text-gray-100'>{description}</span>
          </p>
        )}
      </div>
    </div>
  );
};
